export type NumberFormat = "plain" | "currency" | "percentage"

export type CurrencyCode = "USD" | "AUD" | "CAD" | "EUR"

export interface FormatOption {
  key: NumberFormat
  display_name: string
}

export interface SupportedCurrency {
  code: CurrencyCode
  display_name: string
}

export interface CustomField {
  id: string
  company_id: string
  entity_type: string
  field_key: string
  display_name: string
  field_type:
    | "text"
    | "number"
    | "date"
    | "boolean"
    | "single_select"
    | "multi_select"
    | "user_reference"
    | "cross_reference"
    | "rich_text"
    | "url"
  format?: NumberFormat
  currency_code?: CurrencyCode
  prompt?: string
  fill_for_record_type: "Client" | "Prospect" | "Household"
  options?: {
    select_options?: string[]
    select_option_colors?: Record<string, string>
    cross_reference_allowed_target_types?: string[]
    user_reference_allowed_user_ids?: string[]
    currency_code?: CurrencyCode
  }
  cross_reference_allowed_target_types?: string[]
  user_reference_allowed_user_ids?: string[]
  sort_order: number
  created_at: Date
  updated_at: Date
  values_count: number
}

export interface CustomFieldsResponse {
  custom_fields: CustomField[]
  formats_by_field_type: Record<string, FormatOption[]>
  supported_currencies: SupportedCurrency[]
}

export function isSummable(fieldType: CustomField["field_type"]): boolean {
  return fieldType === "number"
  // Future: || fieldType === "currency"
}

export function customFieldLabel(field: CustomField): string {
  if (field.format === "currency" && field.currency_code && field.currency_code !== "USD") {
    return `${field.display_name} (${field.currency_code})`
  }
  return field.display_name
}
